var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsFbGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_good",
    "data-name": "ico/good",
    transform: "translate(20155 5183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_4051",
    "data-name": "\\u9577\\u65B9\\u5F62 4051",
    width: 48,
    height: 48,
    transform: "translate(-20155 -5183)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico_good-2",
    "data-name": "ico/good",
    d: "M29.626,35.549H9.482V10.938H9.477L19.2,1.28A4.239,4.239,0,0,1,21.418.073,3.961,3.961,0,0,1,22.166,0a3.765,3.765,0,0,1,1.651.388,3.289,3.289,0,0,1,1.633,1.684,3.441,3.441,0,0,1,.156,2.4l-1.686,6.467H35.183A4.634,4.634,0,0,1,38.537,12.4,4.638,4.638,0,0,1,40,15.758v2.068a4.053,4.053,0,0,1-.091.816,4.418,4.418,0,0,1-.233.778L34.069,32.674a4.732,4.732,0,0,1-1.813,2.047A4.788,4.788,0,0,1,29.626,35.549Zm-22.306,0h-2.5a4.671,4.671,0,0,1-3.415-1.4A4.672,4.672,0,0,1,0,30.731V15.758a4.672,4.672,0,0,1,1.4-3.416,4.671,4.671,0,0,1,3.415-1.4h.665V35.546H7.32Z",
    transform: "translate(-20151 -5176.774)",
    fill: "#248cb7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFbGood);
export default __webpack_public_path__ + "static/media/icons_fb_good.ff4818c00f35f0c692fc0daab973c02a.svg";
export { ForwardRef as ReactComponent };